import axiosInstance from './axiosInstance';

class PaymentService {
    confirmStripePayment(paymentIntentId) {
        return axiosInstance.post('/events/checkout/card/success', { paymentId: paymentIntentId });
    }
}

export default new PaymentService();
